import {
  SafetiesDetailBaseType,
  SafetiesDetailInfoType,
} from "../../../../../../models/detail"
import { convertDataExport } from "./config/convertDataExport"
import { safetyInfoHeader } from "./config/header/safetyInfoHeader"
import { exportFileExcel } from "./workbook"

export const exportExcelFRM303 = async (
  data: SafetiesDetailBaseType[],
  safetyInfo?: SafetiesDetailInfoType,
) => {
  const header = safetyInfoHeader(data.length, safetyInfo)
  const convertData = convertDataExport(data)
  exportFileExcel(convertData, header)
}
